import { Checkbox, Form } from 'antd';
import { padWithZeros } from 'common/components/product-add/components/utils/validation';

export const PLUItem = (props) => {
  const { isProductOverlay } = props;

  const form = Form.useFormInstance();

  return (
    <Form.Item
      label='PLU Item'
      name='isPluItem'
      valuePropName='checked'
      colon={false}
      labelCol={{ flex: 'auto' }}
      wrapperCol={{ flex: 'auto' }}
      style={{ paddingRight: 16 }}
    >
      <Checkbox
        disabled={isProductOverlay}
        onChange={(e) => {
          const isChecked = e.target.checked;
          const plu = form.getFieldValue('plu');

          if (isChecked && plu) {
            // Auto-populate UPC12 and GTIN
            const paddedUpc12 = padWithZeros(plu, 12);
            const paddedGtin = padWithZeros(plu, 14);

            form.setFieldsValue({
              upc12: paddedUpc12,
              gtin: paddedGtin,
            });
          } else {
            form.setFieldsValue({
              plu: null,
            });
          }

          // Trigger validation on all identifier fields
          form.validateFields(['gtin', 'upc12', 'upc8', 'upc13']);
        }}
      />
    </Form.Item>
  );
};
